import { createContext, useContext } from 'react';

type MyLearningTabContextType = {
  currentTab: string;
  onTabChange: (value: string) => void;
};

const MyLearningTabContext = createContext<MyLearningTabContextType | undefined>(undefined);

/**
 * @description Used to get the current my learning tab and the function to change the tab
 * @returns {currentTab, onTabChange}
 */
export const useCurrentMyLearningTab = () => {
  const context = useContext(MyLearningTabContext);

  return { currentTab: context?.currentTab, onTabChange: context?.onTabChange };
};

export default MyLearningTabContext;
